export default __webpack_public_path__ + "static/media/Upstocks.6944e73d.svg";